<template>
	<div>
		<ListHeaderComponent :background="background">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<FiltersComponents></FiltersComponents>
		<JudgesComponent></JudgesComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import FiltersComponents from '@/components/JudgesList/FiltersComponents'
	import JudgesComponent from '@/components/JudgesList/JudgesComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			ListHeaderComponent,
			FiltersComponents,
			JudgesComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('judges.header'),
				background: 'judges'
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/JudgesList.vue